import { notification, Progress } from 'ant-design-vue'
import observer from '@/utils/observer'

const origin = location.origin
const protocol = location.protocol

async function * createAsyncBodyReader(readable) {
  while (true) {
    const { value, done } = await readable.read()
    if (done) {
      break
    }
    yield value
  }
}

export function isSameOrigin(url) {
  // url与域名相同 或 url起始为 域名+/
  // url以 / 开头 但不以 //开头
  // url以非 / 开头 并且不是https?:开头
  // url以 // 开头
  // url 以ftp:// 开头 chrome 后面可能不会支持ftp协议

  return (
    (url + '/').startsWith(origin) ||
    (/^\//.test(url) && !/\/\//.test(url)) ||
    (/^[^\/]/.test(url) && !/^https?:\/\//.test(url)) ||
    (protocol + url + '/').startsWith(origin) ||
    (protocol === 'http:' && url.startsWith('ftp://')) // 不支持ftps，也不支持ftp+https
  )
}

function getSourceName(url) {
  const extEndPos = url.lastIndexOf('.')
  if (extEndPos > -1 && url.indexOf('/', extEndPos)) {
    return url.substring(url.lastIndexOf('/') + 1)
  } else {
    return new Date().toISOString().replace(/:/g, '_') + '.bin'
  }
}

export function download(url, filename, options) {
  if (
    isSameOrigin(url) &&
    ((options && (!options.method || options.method.toLowerCase() === 'get')) ||
      !options)
  ) {
    downloadSameOrigin(url, filename || getSourceName(url))
  } else {
    downloadRemote(url, filename, options)
  }
}

export function downloadSameOrigin(url, filename) {
  const a = document.createElement('a')
  a.download = filename
  a.href = url
  a.click()
  a.remove()
}

export function downloadFile(file) {
  const url = URL.createObjectURL(file)
  downloadSameOrigin(url, file.name)
  URL.revokeObjectURL(url)
}

export function downloadRemote(
  url,
  filename,
  options = undefined,
  transformData = true
) {
  return new Promise((resolve, reject) => {
    const _options = options || {}
    if (_options.credentials === undefined) {
      _options.credentials = 'same-origin'
    }

    _options.headers = Object.assign(_options.headers || {}, { 'X-CTName': process.env.VUE_APP_TOKEN_CTNAME })

    fetch(url, _options)
      .then(async res => {
        let _filename = ''
        if (filename) {
          _filename = filename
        } else {
          const disposition = res.headers.get('Content-Disposition')
          if (disposition) {
            _filename = decodeURIComponent(
              disposition
                .split('; ', 2)[1]
                .replace(/filename=(['"]?)(.+)\1/, '$2')
            )
          } else {
            _filename = getSourceName(res.url)
          }
        }

        const chunks = []

        if (res.body) {
          const len = parseInt(res.headers.get('Content-Length') || 0)
          let total = 0
          const reader = res.body.getReader()
          const asyncIterable = createAsyncBodyReader(reader)

          let key = String(Date.now())
          let timer = null

          const instance = observer.$createElement({
            data() {
              return {
                percent: 0,
                status: ''
              }
            },
            render(h) {
              return h(Progress, {
                props: {
                  percent: this.percent,
                  strokeColor: this.status
                }
              })
            }
          })

          const nmsg =
            _filename.length > 25
              ? _filename.substring(0, 22) + '...'
              : _filename

          notification.open({
            key,
            message: nmsg,
            description: instance,
            placement: 'bottomRight',
            duration: null,
            onClose() {
              key = null
              if (timer !== null) {
                clearTimeout(timer)
              }
              instance.componentInstance.$destroy()
            }
          })

          try {
            for await (const chunk of asyncIterable) {
              total += chunk.length || 0

              instance.componentInstance.percent = parseInt(
                (total / len) * 100
              )

              chunks.push(chunk)
            }
            if (transformData) {
              const file = new File(chunks, _filename)
              downloadFile(file)
              resolve(file)
            } else {
              resolve(chunks)
            }
            if (key !== null) {
              timer = window.setTimeout(() => {
                clearTimeout(timer)
                timer = null
                notification.close(key)
              }, 3000)
            }
          } catch (err) {
            instance.componentInstance.status = 'exception'
            reject(err)
          }
        } else {
          reject('没有数据')
        }
      })
      .catch(reject)
  })
}
